import { BASE_URL, UAPI_URL_CONFIG } from './../config/index'

//#region Api Calling for getworkflow master List
export const getWFMasterList = async () => {

    // let url = `${BASE_URL}getworkflowmasterdata`
    let url = `${UAPI_URL_CONFIG}workflow/getNodeMasterList`


    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken'),
         },
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            ////sessionStorage.setItem('workflow-master', JSON.stringify(data.message))
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api Calling LoadWorkflows 
export const loadWorkflows = async (userId) => {
    // let url = `${BASE_URL}workflowstepscrud`
    let url = `${UAPI_URL_CONFIG}workflow/getWorkflow?userId=${userId}`

    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json',
            authcode: localStorage.getItem("authCode"),
            Authorization: "Bearer " + localStorage.getItem("authToken"),
         },
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api Calling LoadWorkflows 
export const getWorkflowById = async (userId, id) => {

    let url = `${UAPI_URL_CONFIG}workflow/getWorkflowById?userId=${userId}&workflowId=${id}`
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json',
            authcode: localStorage.getItem("authCode"),
            Authorization: "Bearer " + localStorage.getItem("authToken"),
         },
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api Calling WorkflowOperations
export const workFlowOperations = async (userId, workflowId) => {

    // let url = `${BASE_URL}workflowstepscrud`
    let url = `${UAPI_URL_CONFIG}workflow/deleteWorkflow?userId=${userId}&workflowId=${workflowId}`

    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api Calling WorkflowOperations
export const addWorkFlowAPI = async (obj) => {

    // let url = `${BASE_URL}workflowstepscrud`
    let url = `${UAPI_URL_CONFIG}workflow/addWorkflow`

    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken'),
         },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

//#region Api Calling WorkflowOperations
export const updateWorkFlowAPI = async (obj) => {

    let url = `${UAPI_URL_CONFIG}workflow/updateWorkflow`

    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            "authcode": localStorage.getItem('authCode'),
            "Authorization": "Bearer " + localStorage.getItem('authToken'),
         },
        body: JSON.stringify(obj),
    };

    return await fetch(url, requestOptions)
        .then((resp) => resp.json())
        .then(function (data) {
            return data;
        })
        .catch(function (error) {
            console.error(error);
        });
}
//#endregion

